var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"aurora-event-icon",class:{ 'aurora-event-icon--custom': !_vm.iconName, 'aurora-event-icon--illustrated': !!_vm.iconName }},[(_vm.iconName)?_c('AuroraArtIcon',{attrs:{"name":_vm.iconName}}):_c('img',{attrs:{"src":_vm.imageUrl,"alt":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }